/* eslint-disable */

import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import InputBase from '@material-ui/core/InputBase'
import { withStyles } from '@material-ui/core/styles'
import { Search } from '@material-ui/icons'
import cn from 'classnames'
import { Component } from 'react'

import LabelWrapper from '../LabelWrapper'
import Spinner from '../LoadingIndicator/Spinner'

const WAIT_INTERVAL = 2000
const ENTER_KEY = 13

const styles = theme => ({
  wrapper: {
    '& .bordered': {
      border: `1px solid
        ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`}`,
      borderRadius: '4px',
      backgroundColor: `var(--gameday-inputField-inputSearchBG, ${theme.inputField.inputSearchBG})`,
      '&:focus-within': {
        backgroundColor: `var(--gameday-inputField-inputSearchBGActive, ${theme.inputField.inputSearchBGActive})`,
        borderColor: theme.inputField.inputBorderActive,
        fontWeight: theme.typography.fontWeightBolder,
      },
      '&.has-error': {
        borderColor: theme.status.errorColor,
        backgroundColor: theme.status.errorBG,
      },
    },
    '& .disabled': {
      backgroundColor: `var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`,
      borderColor: `var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`,
      color: `var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`,
      opacity: theme.inputField.inputDisabledOpacity,
    },
    '& .fullWidth': {
      width: '100%',
    },
  },
  root: {
    display: 'flex',
    height: '34px',
  },
  input: {
    minWidth: 180,
    padding: '0 6px 0 0',
  },
  adornment: {
    marginRight: 0,
    padding: '0 4px',
  },
  searchIcon: {
    padding: '4px',
    '&:hover': {
      background: 'none',
    },
  },
})

class SearchInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.searchText ? props.searchText : '',
    }
  }

  timer = null

  componentWillUnmount() {
    clearTimeout(this.timer)
  }
  componentWillReceiveProps(nextProps) {
    const { searchText } = nextProps
    if (searchText !== this.props.searchText) {
      this.setState({ value: searchText })
    }
  }
  handleChange = e => {
    clearTimeout(this.timer)

    this.setState({ value: e.target.value })

    this.timer = setTimeout(this.triggerChange, this.props.delay)
  }

  handleKeyDown = e => {
    if (e.keyCode === ENTER_KEY) {
      clearTimeout(this.timer)
      this.triggerChange()
    }
  }

  triggerChange = () => {
    const { value } = this.state

    this.props.onChange(value)
  }

  render() {
    const {
      classes,
      className,
      customCol,
      customMargin,
      customPadding,
      customWidth,
      disabled,
      errorText,
      fullWidth,
      helperText,
      icon,
      id,
      isLabelInline,
      isRequired,
      isSearching,
      isToolTip,
      justify,
      label,
      labelIcon,
      noMobile,
      notWrapper,
      noWrap,
      spacing,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      withBorder,
      withDivider,
      ...rest
    } = this.props

    return (
      <LabelWrapper
        className={cn(className, classes.wrapper)}
        customCol={customCol}
        customMargin={customMargin}
        customPadding={customPadding}
        customWidth={customWidth}
        disabled={disabled}
        errorText={errorText}
        fullWidth={fullWidth}
        helperText={helperText}
        id={id}
        label={label}
        isLabelInline={isLabelInline}
        isRequired={isRequired}
        isToolTip={isToolTip}
        justify={justify}
        notWrapper={notWrapper}
        noWrap={noWrap}
        spacing={spacing}
        toolTipIcon={toolTipIcon}
        toolTipIconColor={toolTipIconColor}
        toolTipIconSize={toolTipIconSize}
        toolTipPosition={toolTipPosition}
        toolTipText={toolTipText}
        withBorder={withBorder}
        withDivider={withDivider}
      >
        <InputBase
          classes={{
            root: classes.root,
            input: classes.input,
          }}
          className={cn({ fullWidth })}
          disabled={disabled}
          id={id}
          type={rest.type}
          placeholder={rest.placeholder}
          value={this.state.value}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          startAdornment={
            <InputAdornment position="start" classes={{ root: classes.adornment }}>
              {!isSearching && icon && (
                <IconButton
                  className={classes.searchIcon}
                  onClick={() => !rest.isLockedIcon && handleOnClickIcon()}
                  aria-label="Search"
                  disableRipple
                  disabled={disabled}
                >
                  <Search style={{ fontSize: 20 }} />
                </IconButton>
              )}
              {isSearching && <Spinner searching />}
            </InputAdornment>
          }
        />
      </LabelWrapper>
    )
  }
}

SearchInput.defaultProps = {
  delay: WAIT_INTERVAL,
  label: '',
  placeholder: '',
  required: false,
  type: 'text',
  isFullWidth: false,
  isLockedIcon: false,
  isError: false,
  isSearching: false,
  disabled: false,
  icon: true,
  className: '',
  onChange: f => f,
  onFocus: f => f,
  onSubmit: f => f,
  onBlur: f => f,
  handleOnClickIcon: () => 0,
  notWrapper: true,
}

const SearchInputComponent = withStyles(styles)(SearchInput)
SearchInputComponent.displayName = 'SearchInput'
export default SearchInputComponent
